module.exports = __webpack_public_path__ + "media/images/woman-success-yellow-bg-db7335ae4ae9c1543810af925b30c58f.svg";